// import React, { useState, useEffect, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
// import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
// import { BASE_URL } from "../../Api/ApiUrls";

// // ─────────────────────────────────────────────────────────────────────────────
// // Helper: Haversine distance (km)
// // ─────────────────────────────────────────────────────────────────────────────
// const calculateDistance = (lat1, lon1, lat2, lon2) => {
//   const R = 6371;
//   const dLat = ((lat2 - lat1) * Math.PI) / 180;
//   const dLon = ((lon2 - lon1) * Math.PI) / 180;
//   const a =
//     Math.sin(dLat / 2) * Math.sin(dLat / 2) +
//     Math.cos((lat1 * Math.PI) / 180) *
//       Math.cos((lat2 * Math.PI) / 180) *
//       Math.sin(dLon / 2) *
//       Math.sin(dLon / 2);
//   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
//   return R * c;
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // Helper: Read user location from localStorage
// // ─────────────────────────────────────────────────────────────────────────────
// const getUserLocation = () => {
//   const lat = localStorage.getItem("userLatitude");
//   const lng = localStorage.getItem("userLongitude");
//   const address = localStorage.getItem("userLocation");
//   if (lat && lng) {
//     return {
//       latitude: parseFloat(lat),
//       longitude: parseFloat(lng),
//       address: address || "Current Location",
//     };
//   }
//   return null;
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // Helper: Check displaying_pannels
// // ─────────────────────────────────────────────────────────────────────────────
// const matchesPanel = (displayingPannels, panel) => {
//   if (!displayingPannels) return false;

//   let values = [];
//   if (Array.isArray(displayingPannels)) {
//     values = displayingPannels.map((v) =>
//       typeof v === "string" ? v : v?.name || v?.value || String(v)
//     );
//   } else if (typeof displayingPannels === "string") {
//     values = displayingPannels.split(",").map((s) => s.trim());
//   } else if (typeof displayingPannels === "object") {
//     values = Object.values(displayingPannels).map(String);
//   } else {
//     values = [String(displayingPannels)];
//   }

//   const prefix = `${panel}_`.toLowerCase();
//   return values.some((v) => String(v).toLowerCase().startsWith(prefix));
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // Helper: price per sqft string
// // ─────────────────────────────────────────────────────────────────────────────
// const formatPricePerSft = (value) => {
//   if (!value) return "₹9000 per Sft";
//   const num = Number(value);
//   if (Number.isNaN(num)) return String(value);
//   return `₹${num.toLocaleString("en-IN")} per Sft`;
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // Helper: priority rank (0 = High, 1 = Medium, 2 = Low)
// //   Accepts: "High" / "Medium" / "Low", "H"/"M"/"L", 1/2/3,
// //            "urgent", "critical", "normal" ...
// //   If field is missing → defaults to Medium (1)
// // ─────────────────────────────────────────────────────────────────────────────
// const getPriorityRank = (item) => {
//   if (!item) return 1;

//   const raw =
//     item?.priority ??
//     item?.priority_level ??
//     item?.ad_priority ??
//     item?.priority_order ??
//     item?.weight ??
//     item?.sort_order ??
//     null;

//   if (raw == null) return 1; // default → Medium

//   // Numeric: assume 1 = highest (most common convention)
//   if (typeof raw === "number" && Number.isFinite(raw)) {
//     if (raw <= 1) return 0;
//     if (raw === 2) return 1;
//     return 2;
//   }

//   const s = String(raw).trim().toLowerCase();

//   if (
//     s === "h" ||
//     s === "1" ||
//     s.startsWith("high") ||
//     s === "urgent" ||
//     s === "critical"
//   )
//     return 0;

//   if (s === "m" || s === "2" || s.startsWith("med") || s === "normal") return 1;

//   if (s === "l" || s === "3" || s.startsWith("low")) return 2;

//   return 1; // unknown → Medium
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // Shared hook — fetches ads ONCE per panel, filters by location,
// // then SORTS BY PRIORITY (high → medium → low) then DISTANCE (nearest first)
// // ─────────────────────────────────────────────────────────────────────────────
// export const useAdsForPanel = (panel) => {
//   const [allProperties, setAllProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [userLocation, setUserLocation] = useState(null);
//   const [locationLoading, setLocationLoading] = useState(true);

//   // read + watch location
//   useEffect(() => {
//     setUserLocation(getUserLocation());
//     setLocationLoading(false);

//     const handleLocationChange = () => setUserLocation(getUserLocation());
//     window.addEventListener("storage", handleLocationChange);

//     const interval = setInterval(() => {
//       const l = getUserLocation();
//       if (l) setUserLocation(l);
//     }, 3000);

//     return () => {
//       window.removeEventListener("storage", handleLocationChange);
//       clearInterval(interval);
//     };
//   }, []);

//   // fetch + panel filter
//   useEffect(() => {
//     if (!panel) {
//       setAllProperties([]);
//       setLoading(false);
//       return;
//     }

//     let cancelled = false;

//     (async () => {
//       try {
//         setLoading(true);
//         const res = await fetch(`${BASE_URL}/ad-properties/combined/`);
//         const data = await res.json();

//         let rawList = [];
//         if (Array.isArray(data)) rawList = data;
//         else if (Array.isArray(data?.data)) rawList = data.data;
//         else if (data?.data && typeof data.data === "object") rawList = [data.data];
//         else if (Array.isArray(data?.results)) rawList = data.results;

//         const panelFiltered = rawList.filter((item) =>
//           matchesPanel(item.displaying_pannels, panel)
//         );

//         const propertyData = panelFiltered.map((item) => {
//           const lat = item.lat ? parseFloat(item.lat) : null;
//           const long = item.long ? parseFloat(item.long) : null;
//           const radiusDistance = item.radius_distance
//             ? parseFloat(item.radius_distance)
//             : null;
//           const heroImg = item.hero_images?.[0]?.image || item.image || null;

//           let tagsArray = [];
//           if (Array.isArray(item.tags)) tagsArray = item.tags;
//           else if (typeof item.tags === "string" && item.tags.trim())
//             tagsArray = item.tags.split(",").map((t) => t.trim());
//           else tagsArray = ["1 BHK", "2 BHK", "3 BHK"];

//           return {
//             id: item.property_id ?? item.id,
//             type: item.property_type || "Premium",
//             title: item.property_name || "Property",
//             subtitle: item.property_type || "Premium Apartments",
//             price: item.price
//               ? `₹${Number(item.price).toLocaleString("en-IN")}`
//               : item.max_budget
//               ? `₹${Number(item.max_budget).toLocaleString("en-IN")}`
//               : "₹3.25 Cr",
//             pricePerSft: formatPricePerSft(item.price_per_sqft),
//             location: item.address || item.city || "Location not specified",
//             image: heroImg,
//             category: item.category_name || "",
//             tags: tagsArray,
//             description: item.description || "",
//             lat,
//             long,
//             radius_distance: radiusDistance,
//             displaying_pannels: item.displaying_pannels,
//             // ── NEW: priority rank (0=High, 1=Medium, 2=Low) ──
//             priority: getPriorityRank(item),
//             priorityRaw:
//               item.priority ??
//               item.priority_level ??
//               item.ad_priority ??
//               item.priority_order ??
//               null,
//             _distance: null,
//           };
//         });

//         if (!cancelled) setAllProperties(propertyData);
//       } catch (err) {
//         console.error("Error fetching ad properties:", err);
//         if (!cancelled) setAllProperties([]);
//       } finally {
//         if (!cancelled) setLoading(false);
//       }
//     })();

//     return () => {
//       cancelled = true;
//     };
//   }, [panel]);

//   // location filter + PRIORITY sort
//   const ads = useMemo(() => {
//     if (!userLocation) return [];

//     const filtered = allProperties.filter((p) => {
//       if (!p.lat || !p.long) return false;
//       const d = calculateDistance(
//         userLocation.latitude,
//         userLocation.longitude,
//         p.lat,
//         p.long
//       );
//       p._distance = d;
//       return d <= (p.radius_distance || 10);
//     });

//     // 1) Priority first (High → Medium → Low)
//     // 2) Then distance (nearest first)
//     filtered.sort((a, b) => {
//       if (a.priority !== b.priority) return a.priority - b.priority;
//       return (a._distance || 0) - (b._distance || 0);
//     });

//     return filtered;
//   }, [allProperties, userLocation]);

//   return { ads, loading: loading || locationLoading };
// };

// // ─────────────────────────────────────────────────────────────────────────────
// // Component — renders a SLICE of ads starting at `offset`
// // ─────────────────────────────────────────────────────────────────────────────
// const AddPropertyCards = ({ ads = [], offset = 0, loading = false }) => {
//   const navigate = useNavigate();

//   // Skeleton only for the FIRST block while ads are loading
//   if (loading) {
//     if (offset !== 0) return null;
//     return (
//       <div className="property-wrapper">
//         <div className="skeleton-featured"></div>
//         <div className="skeleton-grid">
//           <div className="skeleton-box"></div>
//           <div className="skeleton-box"></div>
//         </div>
//         <style>{`
//           .property-wrapper { width: 100%; max-width: 500px; margin: 0 auto; padding: 5px; background: rgb(239, 231, 221); }
//           .skeleton-featured { height: 145px; background: #e0e0e0; border-radius: 12px; margin-bottom: 12px; animation: pulse 1.5s infinite; }
//           .skeleton-grid { display: flex; gap: 10px; }
//           .skeleton-box { flex: 1; height: 220px; background: #e0e0e0; border-radius: 12px; animation: pulse 1.5s infinite; }
//           @keyframes pulse { 0% { opacity: 0.6; } 50% { opacity: 1; } 100% { opacity: 0.6; } }
//         `}</style>
//       </div>
//     );
//   }

//   // take the next 3 ads for this block
//   const visibleAds = ads.slice(offset, offset + 3);
//   if (visibleAds.length === 0) return null; // nothing left at this offset

//   const featuredProperty = visibleAds[0];
//   const gridProperties = visibleAds.slice(1, 3);

//   return (
//     <div className="property-wrapper">
//       {/* 1. FEATURED CARD */}
//       {featuredProperty && (
//         <div
//           className="featured-card-large"
//           onClick={() =>
//             navigate(`/new-launching-properties/${featuredProperty.id}`)
//           }
//           style={{ cursor: "pointer" }}
//         >
//           {/* LEFT CONTENT */}
//           <div className="featured-content-left">
//             <div>
//               {/* PRICE + ICON ROW */}
//               <div className="price-icon-row">
//                 <div className="building-icon-circle">
//                   <BusinessOutlinedIcon className="building-icon-svg" />
//                 </div>
//                 <div className="price-text-block">
//                   <h2 className="featured-price">{featuredProperty.price}</h2>
//                   <p className="featured-psf">{featuredProperty.pricePerSft}</p>
//                 </div>
//               </div>

//               {/* TAGS PILLS ROW (first 3) */}
//               {featuredProperty.tags && featuredProperty.tags.length > 0 && (
//                 <div className="tags-container">
//                   {featuredProperty.tags.slice(0, 3).map((tag, idx) => (
//                     <span key={idx} className="tag-pill">
//                       {tag}
//                     </span>
//                   ))}
//                 </div>
//               )}
//             </div>

//             {/* TITLE + LOCATION */}
//             <div className="title-location-block">
//               <h3 className="featured-title">{featuredProperty.title}</h3>
//               <p className="featured-location-text">
//                 {featuredProperty.location}
//               </p>
//             </div>
//           </div>

//           {/* RIGHT IMAGE */}
//           <div className="featured-image-right">
//             <span className="badge featured-badge">Featured</span>
//             <img
//               src={
//                 featuredProperty.image
//                   ? `${BASE_URL}${featuredProperty.image}`
//                   : "https://via.placeholder.com/300x400?text=Property"
//               }
//               alt={featuredProperty.title}
//               onError={(e) => {
//                 e.target.src =
//                   "https://via.placeholder.com/300x400?text=Property";
//               }}
//             />
//           </div>
//         </div>
//       )}

//       {/* 2. GRID CARDS (2 in a row) */}
//       {gridProperties.length > 0 && (
//         <div className="property-grid">
//           {gridProperties.map((property, index) => {
//             const badgeText = index % 2 === 0 ? "New Launching" : "Premium";
//             const badgeClass = index % 2 === 0 ? "badge-new" : "badge-premium";

//             return (
//               <div
//                 key={property.id}
//                 className="grid-card"
//                 onClick={() =>
//                   navigate(`/new-launching-properties/${property.id}`)
//                 }
//                 style={{ cursor: "pointer" }}
//               >
//                 <div className="grid-image-section">
//                   <span className={`badge ${badgeClass}`}>{badgeText}</span>
//                   <img
//                     src={
//                       property.image
//                         ? `${BASE_URL}${property.image}`
//                         : "https://via.placeholder.com/200x200?text=Property"
//                     }
//                     alt={property.title}
//                     onError={(e) => {
//                       e.target.src =
//                         "https://via.placeholder.com/200x200?text=Property";
//                     }}
//                   />
//                 </div>

//                 <div className="grid-content-section">
//                   <h4 className="grid-title">{property.title}</h4>
//                   <p className="grid-location">{property.location}</p>
//                   <p className="grid-price">{property.price}</p>
//                   <p className="grid-details">2 BHK • 1850 Sqft • 2 Baths</p>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       )}

//       {/* ─── CSS STYLES ────────────────────────────────────────────────── */}
//       <style>{`
//         * { box-sizing: border-box; }

//         .property-wrapper {
//           width: 100%;
//           max-width: 500px;
//           margin: 0 auto;
//           padding: 5px;
//           font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
//           background: rgb(239, 231, 221);
//         }

//         /* ── FEATURED LARGE CARD ── */
//         .featured-card-large {
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           background: #F7F2EA;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: 0 4px 12px rgba(0,0,0,0.08);
//           margin-bottom: 12px;
//           height: 145px;
//         }

//         .featured-content-left {
//           padding: 10px;
//           display: flex;
//           flex-direction: column;
//           justify-content: space-between;
//           min-width: 0;
//           min-height: 0;
//           background: #F7F2EA;
//           overflow: hidden;
//         }

//         .price-icon-row {
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .building-icon-circle {
//           width: 32px;
//           height: 32px;
//           border-radius: 50%;
//           background: transparent;
//           border: 1px solid #000000;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           flex-shrink: 0;
//         }

//         .building-icon-svg {
//           color: #000000;
//           font-size: 18px;
//         }

//         .price-text-block { min-width: 0; }

//         .featured-price {
//           margin: 0;
//           font-size: 14px;
//           font-weight: 800;
//           color: #5B4526;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .featured-psf {
//           margin: 1px 0 0 0;
//           font-size: 14px;
//           font-weight: 700;
//           color: #1E1B16;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .tags-container {
//           display: grid;
//           grid-template-columns: repeat(3, 1fr);
//           gap: 4px;
//           margin-top: 10px;
//         }

//         .tag-pill {
//           background: #cec7c7;
//           color: #333333;
//           font-size: 11px;
//           font-weight: 600;
//           padding: 3px 4px;
//           border-radius: 20px;
//           text-align: center;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//           border: 1px solid #f0ebe4;
//         }

//         .title-location-block {
//           text-align: center;
//           margin-top: 8px;
//         }

//         .featured-title {
//           margin: 0;
//           font-size: 14px;
//           font-weight: 800;
//           color: #1E1B16;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .featured-location-text {
//           margin: 3px 0 0 0;
//           font-size: 14px;
//           font-weight: 600;
//           color: #1E1B16;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .featured-image-right {
//           position: relative;
//           width: 100%;
//           height: 100%;
//           overflow: hidden;
//           background: #E8DFD1;
//         }

//         .featured-image-right img {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           object-position: center;
//           display: block;
//         }

//         /* ── GRID CARDS (2 IN A ROW) ── */
//         .property-grid {
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           gap: 10px;
//         }

//         .grid-card {
//           background: #fff;
//           border-radius: 12px;
//           overflow: hidden;
//           box-shadow: 0 3px 10px rgba(0,0,0,0.06);
//           display: flex;
//           flex-direction: column;
//         }

//         .grid-image-section {
//           position: relative;
//           width: 100%;
//           height: 130px;
//           overflow: hidden;
//           background: #EEE7DD;
//         }

//         .grid-image-section img {
//           position: absolute;
//           top: 0;
//           left: 0;
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//           object-position: center;
//           display: block;
//         }

//         .grid-content-section {
//           padding: 10px;
//           display: flex;
//           flex-direction: column;
//           gap: 3px;
//           min-height: 0;
//         }

//         .grid-title {
//           margin: 0;
//           font-size: 13px;
//           font-weight: 800;
//           color: #111;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .grid-location {
//           margin: 0;
//           font-size: 10px;
//           color: #666;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         .grid-price {
//           margin: 3px 0 0 0;
//           font-size: 14px;
//           font-weight: 800;
//           color: #d15b1e;
//         }

//         .grid-details {
//           margin: 0;
//           font-size: 9px;
//           color: #888;
//           white-space: nowrap;
//           overflow: hidden;
//           text-overflow: ellipsis;
//         }

//         /* ── BADGES ── */
//         .badge {
//           position: absolute;
//           top: 8px;
//           left: 8px;
//           padding: 3px 8px;
//           border-radius: 10px;
//           font-size: 9px;
//           font-weight: 700;
//           color: #fff;
//           z-index: 2;
//           box-shadow: 0 2px 4px rgba(0,0,0,0.2);
//         }

//         .featured-badge { background: #a87c51; }
//         .badge-new      { background: #a3a38f; }
//         .badge-premium  { background: #d1a47e; }

//         @media (max-width: 360px) {
//           .grid-image-section { height: 110px; }
//           .featured-title { font-size: 11px; }
//           .grid-title { font-size: 12px; }
//           .featured-card-large { height: 130px; }
//           .building-icon-circle { width: 28px; height: 28px; }
//           .building-icon-svg { font-size: 16px; }
//           .featured-price { font-size: 13px; }
//           .featured-psf { font-size: 9px; }
//           .tag-pill { font-size: 8px; padding: 2px 3px; }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default AddPropertyCards;


import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import { BASE_URL } from "../../Api/ApiUrls";

// ─────────────────────────────────────────────────────────────────────────────
// Helper: Haversine distance (km)
// ─────────────────────────────────────────────────────────────────────────────
const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

// ─────────────────────────────────────────────────────────────────────────────
// Helper: Read user location from localStorage
// ─────────────────────────────────────────────────────────────────────────────
const getUserLocation = () => {
  const lat = localStorage.getItem("userLatitude");
  const lng = localStorage.getItem("userLongitude");
  const address = localStorage.getItem("userLocation");
  if (lat && lng) {
    return {
      latitude: parseFloat(lat),
      longitude: parseFloat(lng),
      address: address || "Current Location",
    };
  }
  return null;
};

// ─────────────────────────────────────────────────────────────────────────────
// Helper: Check displaying_pannels
// ─────────────────────────────────────────────────────────────────────────────
const matchesPanel = (displayingPannels, panel) => {
  if (!displayingPannels) return false;

  let values = [];
  if (Array.isArray(displayingPannels)) {
    values = displayingPannels.map((v) =>
      typeof v === "string" ? v : v?.name || v?.value || String(v)
    );
  } else if (typeof displayingPannels === "string") {
    values = displayingPannels.split(",").map((s) => s.trim());
  } else if (typeof displayingPannels === "object") {
    values = Object.values(displayingPannels).map(String);
  } else {
    values = [String(displayingPannels)];
  }

  const prefix = `${panel}_`.toLowerCase();
  return values.some((v) => String(v).toLowerCase().startsWith(prefix));
};

// ─────────────────────────────────────────────────────────────────────────────
// Helper: price per sqft string
// ─────────────────────────────────────────────────────────────────────────────
const formatPricePerSft = (value) => {
  if (!value) return "₹9000 per Sft";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  return `₹${num.toLocaleString("en-IN")} per Sft`;
};

// ─────────────────────────────────────────────────────────────────────────────
// Helper: priority rank (0 = High, 1 = Medium, 2 = Low)
// ─────────────────────────────────────────────────────────────────────────────
const getPriorityRank = (item) => {
  if (!item) return 1;

  const raw =
    item?.priority ??
    item?.priority_level ??
    item?.ad_priority ??
    item?.priority_order ??
    item?.weight ??
    item?.sort_order ??
    null;

  if (raw == null) return 1;

  if (typeof raw === "number" && Number.isFinite(raw)) {
    if (raw <= 1) return 0;
    if (raw === 2) return 1;
    return 2;
  }

  const s = String(raw).trim().toLowerCase();

  if (
    s === "h" ||
    s === "1" ||
    s.startsWith("high") ||
    s === "urgent" ||
    s === "critical"
  )
    return 0;

  if (s === "m" || s === "2" || s.startsWith("med") || s === "normal") return 1;

  if (s === "l" || s === "3" || s.startsWith("low")) return 2;

  return 1;
};

// ─────────────────────────────────────────────────────────────────────────────
// Shuffle helpers (Fisher–Yates)
// ─────────────────────────────────────────────────────────────────────────────
const shuffleArray = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

// Keeps priority tiers in order (High → Medium → Low),
// but randomises the order WITHIN each tier.
const shuffleWithinPriority = (arr) => {
  const groups = { 0: [], 1: [], 2: [] };
  arr.forEach((a) => {
    const p = a.priority ?? 1;
    if (groups[p]) groups[p].push(a);
    else groups[1].push(a);
  });
  return [
    ...shuffleArray(groups[0]),
    ...shuffleArray(groups[1]),
    ...shuffleArray(groups[2]),
  ];
};

// ─────────────────────────────────────────────────────────────────────────────
// Shared hook — fetches ads ONCE per panel, filters by location,
// then ORDERS them according to `shuffle` mode:
//   • 'within-priority' (default): High → Medium → Low, but random inside tiers
//   • 'full'                     : completely random
//   • 'none'                     : strict priority → distance (original)
// ─────────────────────────────────────────────────────────────────────────────
export const useAdsForPanel = (panel, options = {}) => {
  const {
    shuffle = 'within-priority', // 'within-priority' | 'full' | 'none'
    shuffleKey,                  // bump this prop to force a re-shuffle
  } = options;

  const [allProperties, setAllProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userLocation, setUserLocation] = useState(null);
  const [locationLoading, setLocationLoading] = useState(true);

  // ── read + watch location (update only when coords change) ────────────────
  useEffect(() => {
    setUserLocation(getUserLocation());
    setLocationLoading(false);

    const handleLocationChange = () => {
      const l = getUserLocation();
      if (!l) return;
      setUserLocation((prev) => {
        if (!prev) return l;
        if (
          prev.latitude === l.latitude &&
          prev.longitude === l.longitude
        ) {
          return prev; // same coords → keep same reference (no re-render)
        }
        return l;
      });
    };

    window.addEventListener("storage", handleLocationChange);

    const interval = setInterval(() => {
      const l = getUserLocation();
      if (!l) return;
      setUserLocation((prev) => {
        if (!prev) return l;
        if (
          prev.latitude === l.latitude &&
          prev.longitude === l.longitude
        ) {
          return prev;
        }
        return l;
      });
    }, 3000);

    return () => {
      window.removeEventListener("storage", handleLocationChange);
      clearInterval(interval);
    };
  }, []);

  // ── fetch + panel filter ──────────────────────────────────────────────────
  useEffect(() => {
    if (!panel) {
      setAllProperties([]);
      setLoading(false);
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        setLoading(true);
        const res = await fetch(`${BASE_URL}/ad-properties/combined/`);
        const data = await res.json();

        let rawList = [];
        if (Array.isArray(data)) rawList = data;
        else if (Array.isArray(data?.data)) rawList = data.data;
        else if (data?.data && typeof data.data === "object") rawList = [data.data];
        else if (Array.isArray(data?.results)) rawList = data.results;

        const panelFiltered = rawList.filter((item) =>
          matchesPanel(item.displaying_pannels, panel)
        );

        const propertyData = panelFiltered.map((item) => {
          const lat = item.lat ? parseFloat(item.lat) : null;
          const long = item.long ? parseFloat(item.long) : null;
          const radiusDistance = item.radius_distance
            ? parseFloat(item.radius_distance)
            : null;
          const heroImg = item.hero_images?.[0]?.image || item.image || null;

          let tagsArray = [];
          if (Array.isArray(item.tags)) tagsArray = item.tags;
          else if (typeof item.tags === "string" && item.tags.trim())
            tagsArray = item.tags.split(",").map((t) => t.trim());
          else tagsArray = ["1 BHK", "2 BHK", "3 BHK"];

          return {
            id: item.property_id ?? item.id,
            type: item.property_type || "Premium",
            title: item.property_name || "Property",
            subtitle: item.property_type || "Premium Apartments",
            price: item.price
              ? `₹${Number(item.price).toLocaleString("en-IN")}`
              : item.max_budget
              ? `₹${Number(item.max_budget).toLocaleString("en-IN")}`
              : "₹3.25 Cr",
            pricePerSft: formatPricePerSft(item.price_per_sqft),
            location: item.address || item.city || "Location not specified",
            image: heroImg,
            category: item.category_name || "",
            tags: tagsArray,
            description: item.description || "",
            lat,
            long,
            radius_distance: radiusDistance,
            displaying_pannels: item.displaying_pannels,
            priority: getPriorityRank(item),
            priorityRaw:
              item.priority ??
              item.priority_level ??
              item.ad_priority ??
              item.priority_order ??
              null,
            _distance: null,
          };
        });

        if (!cancelled) setAllProperties(propertyData);
      } catch (err) {
        console.error("Error fetching ad properties:", err);
        if (!cancelled) setAllProperties([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [panel]);

  // ── shuffle cache so location ticks don't re-shuffle displayed ads ────────
  const shuffleCache = useRef({ key: "", ordered: null });

  // ── location filter + ordered list ────────────────────────────────────────
  const ads = useMemo(() => {
    if (!userLocation) return [];

    const filtered = allProperties.filter((p) => {
      if (!p.lat || !p.long) return false;
      const d = calculateDistance(
        userLocation.latitude,
        userLocation.longitude,
        p.lat,
        p.long
      );
      p._distance = d;
      return d <= (p.radius_distance || 10);
    });

    // Cache key: sorted list of ad ids + mode + manual key
    const adsKey = filtered.map((p) => p.id).sort().join(",") +
      `|${shuffle}` +
      `|${shuffleKey ?? ""}`;

    const cache = shuffleCache.current;

    // If the same set of ads → reuse the previous randomised order
    // (only refresh `_distance` for accuracy)
    if (
      cache.key === adsKey &&
      Array.isArray(cache.ordered) &&
      cache.ordered.length === filtered.length
    ) {
      const byId = new Map(filtered.map((p) => [p.id, p]));
      return cache.ordered.map((c) => {
        const fresh = byId.get(c.id);
        return fresh ? { ...c, _distance: fresh._distance } : c;
      });
    }

    // Build fresh order
    let ordered;
    if (shuffle === "full") {
      ordered = shuffleArray(filtered);
    } else if (shuffle === "within-priority") {
      ordered = shuffleWithinPriority(filtered);
    } else {
      // 'none' → strict priority → distance
      ordered = [...filtered].sort((a, b) => {
        if (a.priority !== b.priority) return a.priority - b.priority;
        return (a._distance || 0) - (b._distance || 0);
      });
    }

    shuffleCache.current = { key: adsKey, ordered };
    return ordered;
  }, [allProperties, userLocation, shuffle, shuffleKey]);

  return { ads, loading: loading || locationLoading };
};

// ─────────────────────────────────────────────────────────────────────────────
// Component — renders a SLICE of ads starting at `offset`
// (unchanged except for passing through; shuffling happens in the hook)
// ─────────────────────────────────────────────────────────────────────────────
const AddPropertyCards = ({ ads = [], offset = 0, loading = false }) => {
  const navigate = useNavigate();

  if (loading) {
    if (offset !== 0) return null;
    return (
      <div className="property-wrapper">
        <div className="skeleton-featured"></div>
        <div className="skeleton-grid">
          <div className="skeleton-box"></div>
          <div className="skeleton-box"></div>
        </div>
        <style>{`
          .property-wrapper { width: 100%; max-width: 500px; margin: 0 auto; padding: 5px; background: rgb(239, 231, 221); }
          .skeleton-featured { height: 145px; background: #e0e0e0; border-radius: 12px; margin-bottom: 12px; animation: pulse 1.5s infinite; }
          .skeleton-grid { display: flex; gap: 10px; }
          .skeleton-box { flex: 1; height: 220px; background: #e0e0e0; border-radius: 12px; animation: pulse 1.5s infinite; }
          @keyframes pulse { 0% { opacity: 0.6; } 50% { opacity: 1; } 100% { opacity: 0.6; } }
        `}</style>
      </div>
    );
  }

  const visibleAds = ads.slice(offset, offset + 3);
  if (visibleAds.length === 0) return null;

  const featuredProperty = visibleAds[0];
  const gridProperties = visibleAds.slice(1, 3);

  return (
    <div className="property-wrapper">
      {/* 1. FEATURED CARD */}
      {featuredProperty && (
        <div
          className="featured-card-large"
          onClick={() =>
            navigate(`/new-launching-properties/${featuredProperty.id}`)
          }
          style={{ cursor: "pointer" }}
        >
          <div className="featured-content-left">
            <div>
              <div className="price-icon-row">
                <div className="building-icon-circle">
                  <BusinessOutlinedIcon className="building-icon-svg" />
                </div>
                <div className="price-text-block">
                  <h2 className="featured-price">{featuredProperty.price}</h2>
                  <p className="featured-psf">{featuredProperty.pricePerSft}</p>
                </div>
              </div>

              {featuredProperty.tags && featuredProperty.tags.length > 0 && (
                <div className="tags-container">
                  {featuredProperty.tags.slice(0, 3).map((tag, idx) => (
                    <span key={idx} className="tag-pill">
                      {tag}
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div className="title-location-block">
              <h3 className="featured-title">{featuredProperty.title}</h3>
              <p className="featured-location-text">
                {featuredProperty.location}
              </p>
            </div>
          </div>

          <div className="featured-image-right">
            <span className="badge featured-badge">Featured</span>
            <img
              src={
                featuredProperty.image
                  ? `${BASE_URL}${featuredProperty.image}`
                  : "https://via.placeholder.com/300x400?text=Property"
              }
              alt={featuredProperty.title}
              onError={(e) => {
                e.target.src =
                  "https://via.placeholder.com/300x400?text=Property";
              }}
            />
          </div>
        </div>
      )}

      {/* 2. GRID CARDS (2 in a row) */}
      {gridProperties.length > 0 && (
        <div className="property-grid">
          {gridProperties.map((property, index) => {
            const badgeText = index % 2 === 0 ? "New Launching" : "Premium";
            const badgeClass = index % 2 === 0 ? "badge-new" : "badge-premium";

            return (
              <div
                key={property.id}
                className="grid-card"
                onClick={() =>
                  navigate(`/new-launching-properties/${property.id}`)
                }
                style={{ cursor: "pointer" }}
              >
                <div className="grid-image-section">
                  <span className={`badge ${badgeClass}`}>{badgeText}</span>
                  <img
                    src={
                      property.image
                        ? `${BASE_URL}${property.image}`
                        : "https://via.placeholder.com/200x200?text=Property"
                    }
                    alt={property.title}
                    onError={(e) => {
                      e.target.src =
                        "https://via.placeholder.com/200x200?text=Property";
                    }}
                  />
                </div>

                <div className="grid-content-section">
                  <h4 className="grid-title">{property.title}</h4>
                  <p className="grid-location">{property.location}</p>
                  <p className="grid-price">{property.price}</p>
                  <p className="grid-details">2 BHK • 1850 Sqft • 2 Baths</p>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ─── CSS STYLES (unchanged) ───────────────────────────────────── */}
      <style>{`
        * { box-sizing: border-box; }

        .property-wrapper {
          width: 100%;
          max-width: 500px;
          margin: 0 auto;
          padding: 5px;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
          background: rgb(239, 231, 221);
        }

        .featured-card-large {
          display: grid;
          grid-template-columns: 1fr 1fr;
          background: #F7F2EA;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0,0,0,0.08);
          margin-bottom: 12px;
          height: 145px;
        }

        .featured-content-left {
          padding: 10px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-width: 0;
          min-height: 0;
          background: #F7F2EA;
          overflow: hidden;
        }

        .price-icon-row { display: flex; align-items: center; gap: 8px; }

        .building-icon-circle {
          width: 32px;
          height: 32px;
          border-radius: 50%;
          background: transparent;
          border: 1px solid #000000;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .building-icon-svg { color: #000000; font-size: 18px; }
        .price-text-block { min-width: 0; }

        .featured-price {
          margin: 0;
          font-size: 14px;
          font-weight: 800;
          color: #5B4526;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .featured-psf {
          margin: 1px 0 0 0;
          font-size: 14px;
          font-weight: 700;
          color: #1E1B16;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .tags-container {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 4px;
          margin-top: 10px;
        }

        .tag-pill {
          background: #cec7c7;
          color: #333333;
          font-size: 11px;
          font-weight: 600;
          padding: 3px 4px;
          border-radius: 20px;
          text-align: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          border: 1px solid #f0ebe4;
        }

        .title-location-block { text-align: center; margin-top: 8px; }

        .featured-title {
          margin: 0;
          font-size: 14px;
          font-weight: 800;
          color: #1E1B16;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .featured-location-text {
          margin: 3px 0 0 0;
          font-size: 14px;
          font-weight: 600;
          color: #1E1B16;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .featured-image-right {
          position: relative;
          width: 100%;
          height: 100%;
          overflow: hidden;
          background: #E8DFD1;
        }

        .featured-image-right img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
          display: block;
        }

        .property-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
        }

        .grid-card {
          background: #fff;
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 3px 10px rgba(0,0,0,0.06);
          display: flex;
          flex-direction: column;
        }

        .grid-image-section {
          position: relative;
          width: 100%;
          height: 130px;
          overflow: hidden;
          background: #EEE7DD;
        }

        .grid-image-section img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
          display: block;
        }

        .grid-content-section {
          padding: 10px;
          display: flex;
          flex-direction: column;
          gap: 3px;
          min-height: 0;
        }

        .grid-title {
          margin: 0;
          font-size: 13px;
          font-weight: 800;
          color: #111;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .grid-location {
          margin: 0;
          font-size: 10px;
          color: #666;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .grid-price {
          margin: 3px 0 0 0;
          font-size: 14px;
          font-weight: 800;
          color: #d15b1e;
        }

        .grid-details {
          margin: 0;
          font-size: 9px;
          color: #888;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .badge {
          position: absolute;
          top: 8px;
          left: 8px;
          padding: 3px 8px;
          border-radius: 10px;
          font-size: 9px;
          font-weight: 700;
          color: #fff;
          z-index: 2;
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }

        .featured-badge { background: #a87c51; }
        .badge-new      { background: #a3a38f; }
        .badge-premium  { background: #d1a47e; }

        @media (max-width: 360px) {
          .grid-image-section { height: 110px; }
          .featured-title { font-size: 11px; }
          .grid-title { font-size: 12px; }
          .featured-card-large { height: 130px; }
          .building-icon-circle { width: 28px; height: 28px; }
          .building-icon-svg { font-size: 16px; }
          .featured-price { font-size: 13px; }
          .featured-psf { font-size: 9px; }
          .tag-pill { font-size: 8px; padding: 2px 3px; }
        }
      `}</style>
    </div>
  );
};

export default AddPropertyCards;